import { Routes, Route, Navigate } from "react-router-dom";
import { Shell } from "@/components/layout/Shell";
import { lazy, Suspense } from "react";

// ---------------------------------------------------------------------------
// Lazy-loaded pages
// ---------------------------------------------------------------------------

const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Conversations = lazy(() => import("@/pages/Conversations"));
const Customers = lazy(() => import("@/pages/Customers"));
const Payments = lazy(() => import("@/pages/Payments"));
const KnowledgeBase = lazy(() => import("@/pages/KnowledgeBase"));
const Channels = lazy(() => import("@/pages/Channels"));
const Analytics = lazy(() => import("@/pages/Analytics"));
const Leads = lazy(() => import("@/pages/Leads"));
const Billing = lazy(() => import("@/pages/Billing"));
const Settings = lazy(() => import("@/pages/Settings"));
const Onboarding = lazy(() => import("@/pages/Onboarding"));
const Login = lazy(() => import("@/pages/Login"));
const Landing = lazy(() => import("@/pages/Landing"));
const LiveActivity = lazy(() => import("@/pages/LiveActivity"));
const AgentChat = lazy(() => import("@/pages/AgentChat"));
const Workflows = lazy(() => import("@/pages/Workflows"));
const Approvals = lazy(() => import("@/pages/Approvals"));
const HotelDemo = lazy(() => import("@/pages/HotelDemo"));


// ---------------------------------------------------------------------------
// Loading fallback
// ---------------------------------------------------------------------------

function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// App Router
// ---------------------------------------------------------------------------

export function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/demo" element={<HotelDemo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding" element={<Onboarding />} />

        {/* Authenticated shell */}
        <Route element={<Shell />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
          <Route path="/channels" element={<Channels />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/live" element={<LiveActivity />} />
          <Route path="/agent" element={<AgentChat />} />
          <Route path="/workflows" element={<Workflows />} />
          <Route path="/approvals" element={<Approvals />} />

        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
